import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { route as smallBusinessGrantApplyRoute } from "@faire/web-api--source/routes/www/small-business-grant/apply";

export const smallBusinessGrantApplyRouteMatcher =
  new RouteMatcher<RetailerRoute>([smallBusinessGrantApplyRoute]);
